import timeUtils from '../../qti/utils/TimeUtils';
import testStatusConstants from '../../constants/TestStatusConstants';
import settingsReader from '../../store/readHelpers/SettingsReader';
import timeReader from '../../store/readHelpers/TimeReader';
import testComponentService from '../TestComponentService';
import { t } from '../i18nService';
import sessionReader from '../../store/readHelpers/SessionReader';

const formatTotalDuration = (test) => {
    const isCandidateLevelDurationEnabled = settingsReader.isCandidateLevelDurationEnabled();
    // Duration in seconds (isCandidateLevelDurationEnabled=true) or minutes otherwise
    let totalDuration = isCandidateLevelDurationEnabled ? test.duration : test.duration * 60;
    if (!isNaN(test.extratime)) {
        // extraTime in minutes
        totalDuration += (test.extratime * 60);
    }
    return timeUtils.formatDuration(totalDuration * 1000, t, isCandidateLevelDurationEnabled);
};

const resolveStatusCaption = (test, isCompleted, isPendingFileDeliveryUpload) => {
    if (isCompleted || test.isReadinessCheckComplete) {
        return 'childTest.completed';
    }
    if (isPendingFileDeliveryUpload) {
        return 'childTest.pendingFileDeliveryUpload';
    }
    return 'childTest.notCompleted';
};

// Maps the TestComponent props into deduced props, that way we keep testable logic outside of the component which
// stays really pure (status-free and service-free)
const mapToProps = (ownProps) => {
    const {
        parentTest,
        test,
    } = ownProps;

    // standalone tests do not have a status, thus we provide a default.
    // We put this here instead of directly as a prop, otherwise having a new object every time will trigger multiple renders.
    return mapToPropsWithTestStatus(
        ownProps,
        testComponentService.getTestWithStatus(test),
        testComponentService.getTestWithStatus(parentTest)
    );
};

const mapToPropsWithTestStatus = (ownProps, test, parentTest) => {
    const {
        offlineFileDeliveryStatus,
        isCompleted,
        pendingAssessments,
        livestream,
        idverification,
    } = ownProps;

    const fileDeliveryStatus = (offlineFileDeliveryStatus[test.assessmentRunId] || {}).status;
    const isPendingFileDeliveryUpload = testComponentService.isPendingFileDeliveryUpload(fileDeliveryStatus);
    const isReadinessCheck = test.isReadinessCheck;
    const shouldHighlight = test.status === testStatusConstants.EXECUTING;
    let statusTextClassName = 'incomplete';
    if (isPendingFileDeliveryUpload) {
        statusTextClassName = 'pending';
    } else if (isCompleted) {
        statusTextClassName = 'completed';
    }
    const readinessCheckContentRevisionId = sessionReader.getReadinessCheckContentRevisionId();
    const { settings } = pendingAssessments[readinessCheckContentRevisionId] || {};
    const shouldCacheReadinessResources = settingsReader.shouldCacheResourcesBeforeTestStart(settings);
    const shouldRenderTestActions = testComponentService.shouldRenderTestActions(
        test,
        parentTest,
        offlineFileDeliveryStatus,
        livestream,
        idverification,
    );
    const totalDurationFormatted = formatTotalDuration(test);
    const statusCaption = resolveStatusCaption(test, isCompleted, isPendingFileDeliveryUpload);
    const shouldRenderReadinessCheck = !!isReadinessCheck && !isCompleted && !timeReader.timeHasExpired();

    return {
        shouldHighlight,
        statusTextClassName,
        statusCaption,
        shouldRenderReadinessCheck,
        shouldRenderTestActions,
        shouldCacheReadinessResources,
        readinessCheckContentRevisionId,
        isPendingFileDeliveryUpload,
        totalDurationFormatted,
    };
};

const TestComponentSelector = {
    mapToProps,
};

export default TestComponentSelector;
